import {NOOP_FUNCTION} from "../../stem-core/src/base/Utils";

import {Logger} from "../../blinkpay/Logger";
import {apiMakePayment} from "../state/PaymentStore";


export class BlinkPaymentProcessor {
    constructor() {
        this._logger = new Logger("BlinkPaymentProcessor");
    }

    makePaymentManualConfirmed(paymentRequest, callback = NOOP_FUNCTION, errorCallback = NOOP_FUNCTION) {
        this.makePayment(paymentRequest, callback, errorCallback, true);
    }

    async makePayment(paymentRequest, callback = NOOP_FUNCTION, errorCallback = NOOP_FUNCTION, manualConfirmation = false) {
        // TODO(@sdk-deprecated): currencyIsoCode will be removed from both the payment request and the backend payload.
        const {
            paymentInfoSignature,
            merchantPublicKey,
            amount,
            offerId,
            currencyIsoCode,
            currencyCode,
            resourceId,
            comment,
            merchantId,
        } = paymentRequest;

        this._logger.debug("POSTing payment request to Blink API");
        try {
            const response = await apiMakePayment({
                paymentInfoSignature,
                merchantPublicKey,
                manualConfirmation,
                resourceId,
                offerId,
                amount,
                merchantId,
                currencyIsoCode: currencyCode || currencyIsoCode,
                currencyCode: currencyCode || currencyIsoCode,
                comment: JSON.stringify(comment || {}),
            });
            this._logger.debug("Received payment response from Blink API: ", response);
            callback(response);
        } catch (error) {
            this._logger.debug("Received error from API: ", error);
            errorCallback(error);
        }
    }
}
